import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyInsuranceFormArrayFieldTemplateClasses,
} from '@dxp-module/themes'

const arrayFieldTemplateStyles = makeStyles<
  MyAccountTheme,
  object,
  MyInsuranceFormArrayFieldTemplateClasses
>(
  {
    root: {
      padding: '5px 0',
    },
  },
  { name: 'MyAccount_InsuranceForm_ArrayFieldTemplate' }
)

export default arrayFieldTemplateStyles
